// @flow

export function applyCpfMask(digits: string): string {
  let masked = digits.substring(0, 3);
  if (digits.length > 3) masked += '.' + digits.substring(3, 6);
  if (digits.length > 6) masked += '.' + digits.substring(6, 9);
  if (digits.length > 9) masked += '-' + digits.substring(9, 11);
  return masked;
}
